import { useSelector } from 'react-redux';
import { issuerSelector } from '../selectors';
import type { LoginMethod } from '../selectors/interfaces';
import { EmployeeLoginType } from '../selectors/interfaces';

export const useGetLoginConfig = () => {
  const { login } = useSelector(issuerSelector);

  const getLoginMethodConfig = (loginMethod: LoginMethod, logErrors = true) => {
    if (!login?.supported_login_methods) {
      return undefined;
    }

    if (!login.supported_login_methods.includes(loginMethod)) {
      if (logErrors) {
        console.error(`Login method "${loginMethod}" is not supported`);
      }
      return undefined;
    }

    const loginMethodConfig = login.login_method_config[loginMethod];
    if (!loginMethodConfig) {
      if (logErrors) {
        console.error(
          `Login method "${loginMethod}" should be supported but missed`,
        );
      }
      return undefined;
    }

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return loginMethodConfig;
  };

  const isExternalLoginMethod = (loginMethod: LoginMethod): boolean => {
    const loginMethodConfig = getLoginMethodConfig(loginMethod, false);
    return !!loginMethodConfig?.oauth_login_url;
  };

  const isTerminatedLoginMethod = (
    loginMethod: LoginMethod,
    logErrors = true,
  ): boolean => {
    const methodConfig = getLoginMethodConfig(loginMethod, logErrors);
    if (!methodConfig) {
      return false;
    }
    return methodConfig.user_case.includes(EmployeeLoginType.TERMINATED);
  };

  return {
    getLoginMethodConfig,
    isExternalLoginMethod,
    isTerminatedLoginMethod,
  };
};
